// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/models/user_subscription.proto (package kikoff_canada.protobuf.models, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { SubscriptionPlan } from "./subscription_plan_pb.js";

/**
 * @generated from message kikoff_canada.protobuf.models.UserSubscription
 */
export class UserSubscription extends Message<UserSubscription> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 2;
   */
  startAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 3;
   */
  endAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp terminated_at = 4;
   */
  terminatedAt?: Timestamp;

  /**
   * @generated from field: kikoff_canada.protobuf.models.SubscriptionPlan plan = 5;
   */
  plan?: SubscriptionPlan;

  /**
   * @generated from field: bool active = 6;
   */
  active = false;

  /**
   * @generated from field: bool autorenew_enabled = 7;
   */
  autorenewEnabled = false;

  constructor(data?: PartialMessage<UserSubscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.models.UserSubscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_at", kind: "message", T: Timestamp },
    { no: 3, name: "end_at", kind: "message", T: Timestamp },
    { no: 4, name: "terminated_at", kind: "message", T: Timestamp },
    { no: 5, name: "plan", kind: "message", T: SubscriptionPlan },
    { no: 6, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "autorenew_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserSubscription {
    return new UserSubscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserSubscription {
    return new UserSubscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserSubscription {
    return new UserSubscription().fromJsonString(jsonString, options);
  }

  static equals(a: UserSubscription | PlainMessage<UserSubscription> | undefined, b: UserSubscription | PlainMessage<UserSubscription> | undefined): boolean {
    return proto3.util.equals(UserSubscription, a, b);
  }

  static _enums: {
  };
}

